import React from "react";
import { Box, Typography, Divider, FormControlLabel, Checkbox } from "@mui/material";
import { 
  CaseSheetSection, 
  toTitleCase, 
  BORDER, 
  labelSx, 
  rowSx,
  ACCENT,
  LABEL_COLOR,
  ACCENT_DARK,
  yesNoFields,
  inputSx
} from "./CaseSheetModalComponents";
import ChiefComplaint from "../doctor-console/Sections/ChiefComplaint";
import { ThemeProvider } from "@mui/material/styles";
import { theme as doctorConsoleTheme } from "../doctor-console/StyledComponents";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const diabetesProfileYesNoLabels = {
  hypoglycemia: "Hypoglycemia",
  diabetic_foot: "Diabetic Foot",
  peripheral_neuropathy: "Peripheral Neuropathy",
  peripheral_vascular_disease: "Peripheral Vascular Disease",
  nephropathy: "Nephropathy",
  ckd: "Ckd",
  diabetic_retinopathy: "Diabetes Eye Disorder",
};

const DiabetesTab = ({ 
  formData, 
  setFormData,
  onChiefComplaintsChange,
  isFetching, 
  renderTextField, 
  renderYesNoField,
  renderHypertensionRow,
  renderSelectField, 
  renderOptionToggleField,
  renderSkinHydrationField
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {/* ── Chief Complaints Section ── */}
      <ThemeProvider theme={doctorConsoleTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CaseSheetSection title="CHIEF COMPLAINTS" defaultExpanded>
            <ChiefComplaint
              sectionName="Chief Complaints"
              activeSection={true}
              suggestions={{ aiDriven: [], ruleDriven: [] }}
              aiSuggestionToggle={false}
              ruleSuggestionToggle={false}
              handleCrossButtonClick={() => {}}
              data={formData.chief_complaints || []}
              setData={
                onChiefComplaintsChange ||
                ((newData) => setFormData((prev) => ({ ...prev, chief_complaints: newData })))
              }
              startRecording={() => {}}
              stopRecording={() => {}}
              isAiEnabled={false}
            />
          </CaseSheetSection>
        </LocalizationProvider>
      </ThemeProvider>

      {/* ── History & General Sections ── */}
      <CaseSheetSection title="GENERAL" defaultExpanded>
               {/* {renderTextField("History of Past Illness", "medical_history", "Medical history")}
               {renderTextField("Allergies", "allergies", "Allergies")} */}
               {/* {renderTextField("First Complaints", "first_complaints", "First complaints")} */}
              {renderTextField("Current Treatment", "current_treatment", "Current treatment")}
               {renderTextField("Previous Treatment", "previous_treatment", "Previous treatment")}
               {/* {renderTextField("Family History", "family_history", "Family history")} */}
               {/* {renderTextField("Review", "review", "Review")} */}
            </CaseSheetSection>
      
            {/* <CaseSheetSection title="LIFESTYLE" defaultExpanded>
              {renderYesNoField("Smoking", "smoking")}
              {renderYesNoField(" Alcohol Drinking", "drinking")}
              {renderYesNoField("Tobacco", "tobacco")}
              {renderSelectField("Exercise", "exercise")}
              {renderTextField("Description", "description", "Additional lifestyle details")}
              {renderSelectField("Diet", "diet")}
            </CaseSheetSection> */}
      
            {/* <CaseSheetSection title="HISTORY OF PRESENT ILLNESS" defaultExpanded>
              {renderTextField("Duration", "duration", "Duration of current illness")}
              {renderTextField("Symptoms", "symptoms", "Symptoms details")}
              {renderTextField("Progression", "progression", "Progression details")}
            </CaseSheetSection> */}
      
            {/* <CaseSheetSection title="SURGICAL HISTORY" defaultExpanded>
              {renderTextField("Surgeries History", "surgeries_history", "Details of past surgeries")}
            </CaseSheetSection> */}
      
            {/* <CaseSheetSection title="VACCINATION STATUS" defaultExpanded>
              {renderTextField("Vaccination Status", "vaccination_history", "Details of vaccinations received")}
            </CaseSheetSection> */}
      
            {/* <CaseSheetSection title="MEDICATION HISTORY" defaultExpanded>
              {renderTextField("Current Medications", "current_medications", "Details of current medications  ")}
              {renderOptionToggleField("Compliance", "medication_compliance", [
                "Good",
                "Average",
                "Poor",
              ])}
               {renderTextField("Side Effects", "medication_side_effects", "Details of any medication side effects experienced")}
               <Divider sx={{ borderColor: BORDER }} />
               {renderTextField("Drug Allergies", "drug_allergies", "List drug allergies")}
               {renderTextField("Food Allergies", "food_allergies", "List food allergies")}
             </CaseSheetSection>  */}
      {/* ── Diabetes Specific Sections ── */}
      <CaseSheetSection title="DIABETES PROFILE" defaultExpanded>
        {renderSelectField("Diabetes Type", "diabetes_type")}
        {renderTextField("Onset Time", "diabetes_onset_time", "e.g. 5 years ago")}
        {renderTextField("Diabetes Onset From", "diabetes_onset_from", "Onset details")}
        <Divider sx={{ borderColor: BORDER }} />
        {yesNoFields.slice(3, 9).map((fk) =>
          renderYesNoField(diabetesProfileYesNoLabels[fk] || toTitleCase(fk), fk)
        )}
        {renderYesNoField(
          diabetesProfileYesNoLabels.diabetic_retinopathy,
          "diabetic_retinopathy"
        )}
        {renderHypertensionRow()}
        <Divider sx={{ borderColor: BORDER }} />
        {renderTextField("Lipid Disorders", "lipid_disorders", "Lipid disorders")}
        {renderTextField("Other Ailments", "other_ailments", "Other ailments")}
      </CaseSheetSection>

      <CaseSheetSection title="SKIN EXAMINATION" defaultExpanded>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Status</Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.skin_normal}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFormData((prev) => ({
                    ...prev,
                    skin_normal: checked,
                    ...(checked && {
                      skin_hydration: "",
                      skin_stretchability: "",
                      skin_texture: "",
                    }),
                  }));
                }}
                disabled={isFetching}
                size="small"
                sx={{
                  color: BORDER,
                  "&.Mui-checked": { color: ACCENT },
                  p: 0.5,
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: LABEL_COLOR,
                  userSelect: "none",
                }}
              >
                Normal (No examination required)
              </Typography>
            }
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1.75, sm: 2.25 },
            pointerEvents: formData.skin_normal ? "none" : "auto",
            opacity: formData.skin_normal ? 0.45 : 1,
            transition: "opacity 0.2s ease",
          }}
        >
          {renderSkinHydrationField()}
          {renderOptionToggleField(
            "Stretchability",
            "skin_stretchability",
            ["Good", "Poor"]
          )}
          {renderOptionToggleField("Texture", "skin_texture", [
            "Thickened",
            "Rough",
          ])}
        </Box>
      </CaseSheetSection>

      <CaseSheetSection title="DENTAL STATUS" defaultExpanded>
        <Box sx={rowSx}>
          <Typography sx={labelSx}>Status</Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.dental_normal}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFormData((prev) => ({
                    ...prev,
                    dental_normal: checked,
                    ...(checked && {
                      teeth_status: "",
                      gums_status: "",
                    }),
                  }));
                }}
                disabled={isFetching}
                size="small"
                sx={{
                  color: BORDER,
                  "&.Mui-checked": { color: ACCENT },
                  p: 0.5,
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: LABEL_COLOR,
                  userSelect: "none",
                }}
              >
                Normal (No examination required)
              </Typography>
            }
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1.75, sm: 2.25 },
            pointerEvents: formData.dental_normal ? "none" : "auto",
            opacity: formData.dental_normal ? 0.45 : 1,
            transition: "opacity 0.2s ease",
          }}
        >
          {renderSelectField("Teeth", "teeth_status")}
          {renderSelectField("Gums", "gums_status")}
        </Box>
      </CaseSheetSection>

      <CaseSheetSection title="Investigations" defaultExpanded>
        {renderTextField("Fasting Blood Sugar", "fasting_blood_sugar", "Fasting blood sugar details")}
        {renderTextField("Post Prandial Blood Sugar", "post_prandial_blood_sugar", "Post prandial blood sugar details ")}
        {renderTextField("HbA1c", "hba1c", "HbA1c details")}
        {renderTextField("Lipid Profile", "lipid_profile", "Lipid profile details")}
        {renderTextField("Liver Function Tests", "liver_function_tests", "Liver function tests details")}
        {renderTextField("Kidney Function Tests", "kidney_function_tests", "Kidney function tests details")}
        {renderTextField("Thyroid Profile", "thyroid_profile", "Thyroid profile details")}
        {renderTextField("CBC", "cbc", "CBC details")}
        {renderTextField("FIB-4", "fib_4", "FIB-4 index details")}
        {renderTextField("UACR", "ucar", "UACR details")}
        {renderTextField("Others", "other_investigations", "Other investigations details")}
      </CaseSheetSection>

      <CaseSheetSection title="RISK STRATIFICATION" defaultExpanded>
        {renderSelectField("Cardiovascular Risk", "cardiovascular_risk")}
        {renderYesNoField("Metabolic Syndrome", "metabolic_syndrome")}
      </CaseSheetSection>

      <CaseSheetSection title="DIAGNOSIS" defaultExpanded>
        {renderTextField("Primary(Provisional)Diagnosis", "primary_diagnosis", "Diagnosis details")}
        {renderTextField("Secondary(Definitive) Diagnosis", "secondary_diagnosis", "Secondary diagnosis details")}
      </CaseSheetSection>

      <CaseSheetSection title="TREATMENT PLAN" defaultExpanded>
        {renderTextField("Lifestyle Modifications", "lifestyle_modifications", "Recommended lifestyle modifications")}
        {renderTextField("Diet Plan", "diet_plan")}
        {renderTextField("Exercise", "exercise_plan")}
        {renderTextField("Medications", "treatment_medications")}
      </CaseSheetSection>
{/* 
      <CaseSheetSection title="FOLLOW-UP PLAN" defaultExpanded>  
        {renderTextField("Next Visit", "next_visit", "Details of the next follow-up visit")}
        {renderTextField("Monitoring", "monitoring_plan", "Monitoring plan details")}
      </CaseSheetSection> */}

      <CaseSheetSection title="PATIENT MOTIVATION" defaultExpanded>
        {renderOptionToggleField("Patient Motivation", "patient_motivation", [
          "High",
          "Moderate",
          "Poor",
        ])}
      </CaseSheetSection>
    </Box>
  );
};

export default DiabetesTab;
